import { CIMSPage, isDeleted } from 'shared'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import {
  DocumentChecklistItem,
  useDocumentChecklistsTableContext,
} from '../../../DocumentChecklistsTableContext'
import { HelpMessage } from 'utils/constants'

export function useExpandOptions(): ExpandOptions<DocumentChecklistItem> {
  const {
    metadata: { concreteTestSets },
  } = useDocumentChecklistsTableContext()
  return {
    expandable: ({ documentChecklistValues }) =>
      documentChecklistValues.some(({ checked }) => checked),
    render: ({ id, documentChecklistItemToConcreteMaterials }) => {
      const placementTypes = documentChecklistItemToConcreteMaterials.map(
        ({ concreteMaterial }) => concreteMaterial.placementType
      )
      const relatedTestSets = (concreteTestSets ?? []).filter(
        (testSet) =>
          placementTypes.includes(
            testSet.concreteMaterial?.placementType ?? null
          ) &&
          testSet.documentChecklistValues.some(
            ({ checked, documentChecklistItem }) =>
              documentChecklistItem.id === id && checked
          )
      )
      return {
        additionalInfo: [
          {
            label: 'Associated Test Sets',
            help: HelpMessage.Concrete.DocumentChecklists.AssociatedTestSets,
            type: 'deepLinks',
            showMore: { key: id },
            links: relatedTestSets.map(({ globalId, testSetId, deleted }) => ({
              recordId: globalId,
              label: testSetId,
              page: CIMSPage.ConcreteTestSets,
              deleted: isDeleted(deleted),
            })),
          },
        ],
      }
    },
  }
}
